/* Progressive enhancement only: no local registration form or personal-data storage. */
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-webinar-section]').forEach((section) => {
      if (section.dataset.webinarInitialized) return;
      section.dataset.webinarInitialized = 'true';

      const dialog = section.querySelector('[data-webinar-dialog]');
      const trigger = section.querySelector('[data-webinar-open]');
      const close = section.querySelector('[data-webinar-close]');
      if (dialog && trigger && typeof dialog.showModal === 'function') {
        trigger.hidden = false;
        trigger.addEventListener('click', () => {
          const template = dialog.querySelector('[data-webinar-frame]');
          if (template) {
            template.replaceWith(template.content.cloneNode(true));
          }
          if (!dialog.open) dialog.showModal();
        });
        close?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        });
      }

      const tabs = [...section.querySelectorAll('[data-webinar-tab]')];
      const panels = [...section.querySelectorAll('[data-webinar-panel]')];
      const tablist = section.querySelector('[data-webinar-tabs]');
      if (!tabs.length || !tablist) return;
      tablist.setAttribute('role', 'tablist');
      const activate = (index, focus = false) => {
        tabs.forEach((tab, itemIndex) => {
          const selected = itemIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[itemIndex].hidden = !selected;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.hidden = false;
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0);
      section.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-webinar-panel]');
        if (panel) activate(Number(panel.dataset.webinarPanel));
      });
    });
  };
  initialize();
  const bindUtilityWebinarTrigger = () => {
    const utilityLink = document.querySelector('.utility-row a[href$="#webinar"]');
    const section = document.querySelector('[data-webinar-section]');
    const trigger = section?.querySelector('[data-webinar-open]');
    if (!utilityLink || !trigger || utilityLink.dataset.webinarBound) return;
    utilityLink.dataset.webinarBound = 'true';
    utilityLink.addEventListener('click', (event) => { event.preventDefault(); trigger.click(); });
  };
  bindUtilityWebinarTrigger();
  document.addEventListener('shopify:section:load', bindUtilityWebinarTrigger);
  document.addEventListener('shopify:section:load', () => initialize());
})();
